// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3ToXE","modalForm":"UpgradeEpcsModal_modalForm__3815W","modalFooter":"UpgradeEpcsModal_modalFooter__3dthr"};